interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const baseBtn =
    'min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm font-label transition-colors cursor-pointer';

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? 'page' : undefined}
          className={
            page === current
              ? `${baseBtn} bg-primary-500 text-background-50`
              : `${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500`
          }
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}